import { createReducer } from 'redux-act';
import { setDecisions, setDecisionsLoading } from 'redux/actions/Decisions/viewActions';
import { DEFAULT_PAGINATION } from 'constants/pagination';

const initState = {
  data: [],
  filters: {},
  loading: false,
  pagination: DEFAULT_PAGINATION,
};

const viewReducer = createReducer(
  {
    [setDecisions]: (state, { data, filters, pagination }) => ({
      ...state,
      data,
      filters,
      loading: false,
      pagination,
    }),
    [setDecisionsLoading]: (state, loading) => ({
      ...state,
      loading,
    }),
  },
  initState,
);

export default viewReducer;
